import React from "react";
import { observer } from "mobx-react";
import Scrollbar from "../../ui/Scrollbar";
import useCheersStore from "../../../../../common/hooks/useCheersStore";
import EmoteList from "../../Emotes/EmoteList";
import style from "./CheerEmotes.module.scss";
import { Emote } from "src/common/interfaces/Emote";

interface CheerEmotesProps {
  emotes: Emote[];
}

const CheerEmotes: React.FC<CheerEmotesProps> = observer(({ emotes }) => {
  const cheersStore = useCheersStore();

  const onEmoteClick = (emote: Emote): void => {
    if (emote.id === cheersStore.selectedEmote?.id) {
      cheersStore.deselectEmote();
    } else {
      cheersStore.selectEmote(emote);
    }
  };

  return (
    <div className={style.cheerEmotes}>
      <div className={style.cheerEmotes__title}>Select an emote!</div>
      <div className={style.cheerEmotes__content}>
        <Scrollbar>
          <div className={style.cheerEmotes__emoteWrapper}>
            <EmoteList emotes={emotes} onEmoteClick={onEmoteClick} selectedEmote={cheersStore.selectedEmote} />
          </div>
        </Scrollbar>
      </div>
    </div>
  );
});

export default CheerEmotes;
